import React, { useState } from "react";
import { Grid, Row } from "react-material-responsive-grid";
import Header from "../Home/Header/Default";
import Footer from "../Home/Footer/Default";
import { AppEnv } from "../env";

const Card = (props) => {
  const { title, child } = props;
  return (
    <Row
      className="uk-width-2-3 centerAll"
      style={{
        margin: "10px 0 0 0",
        padding: 20,
        backgroundColor: AppEnv.grayColorOne,
        borderRadius: 6,
      }}
    >
      <Row className="uk-width-1-1 sub_title">{title}</Row>
      <Row
        className="uk-width-1-1 normal_text"
        style={{ margin: "10px 0 0 0", padding: 0, textAlign: "justify" }}
      >
        {child}
      </Row>
    </Row>
  );
};

export default function Documentation() {
  const [language, setLanguage] = useState("es");
  const name =
    AppEnv.tipoApp === "3"
      ? "Kolegia Euducación Pública"
      : "Kolegia School Manager";
  const page =
    AppEnv.tipoApp === "3" ? "educacionpublica.kolegia.com" : "kolegia.com";
  const text = {
    en: [
      {
        title: "Installation",
        texts: [
          <p>
            The user will be able to install the app once the login is completed
            within {name}.
          </p>,
          <p>
            Therefore you will have to enter {page} and log in with your
            credentials.
          </p>,
          <p>
            Once inside your session you can select the Virtual Classroom menu
            and go to the sub menu Status where you can give access to {name} to
            access Zoom
          </p>,
        ],
      },
      {
        title: "Usage:",
        texts: [
          <p>
            The integration with Zoom is given to be able to schedule new
            meetings called classes
          </p>,
          <p>
            Some of the roles to create classes will be administrators and
            teachers
          </p>,
          <p>
            For all cases it is used for consultations, for example: parents and
            students will be able to access to the classes and in turn consult
            the program of virtual classes assigned
          </p>,
          <p>
            For students and parents it is not necessary to integrate or give
            permission to {name} to consult and access their respective classes.
            For teachers and administrators must comply with the previous step
            "Installation"
          </p>,
          <p>
            To create a class, the user must select the Virtual Classroom menu
            and go to the sub menu Create Class, where you will have to choose a
            grade, a group and class module, you will automatically be will
            provide information for the zoom agenda, the user can change it
            according to their needs
          </p>,
          <p>
            To start a class, the user who created the class must select the
            Virtual Classroom menu and go to the sub menu Consult Class, where
            you will have to select grade, group and date, You can view all the
            classes that meet the above criteria and you can use the button
            Start class.
          </p>,
          <p>
            To enter a class the user must select the Virtual Classroom menu and
            go to the sub menu Consult Class, where you will have to select
            grade, group and date, you can view all the classes that meet the
            above criteria and you can use the button Entering class, in cases
            like the father will only have to select his son and the date, in If
            you are a student, you will only have to choose the date.
          </p>,
        ],
      },
      {
        title: "Uninstall",
        texts: [
          <p>
            To uninstall or remove {name} permission to access Zoom you have two
            options:
          </p>,
          <p className="uk-width-1-1">
            Zoom:
            <ol>
              <li>
                Login to your Zoom account and go to Zoom App Marketplace.
              </li>
              <li>Click Manage -> Installed Apps.</li>
              <li>Click on {name}.</li>
              <li>Click Uninstall.</li>
            </ol>
          </p>,
          <p className="uk-width-1-1">
            {name}:
            <ol>
              <li>Login to your {name} account and go to Aula virtual.</li>
              <li>Click Estatus -> Retirar permisos.</li>
              <li>
                However this step will only delete the {name} data, so you will
                still have to do the previous step "Uninstall Zoom option"
              </li>
            </ol>
          </p>,
        ],
      },
      {
        title: "Support",
        texts: [
          <p>
            Please go to <a href={page + "/support"}> {page + "/ support"} </a>
          </p>,
        ],
      },
    ],
    es: [
      {
        title: "Instalación",
        texts: [
          <p>
            El usuario podrá instalar la app una vez que se complete el inicio
            de sesión dentro de {name}.
          </p>,
          <p>
            Por lo cual tendrá que ingresar a {page} y acceder con sus
            credenciales.
          </p>,
          <p>
            Una vez dentro de su sesión podrá seleccionar el menú Aula virtual y
            dirigirse al sub menú Estatus donde podrá dar el acceso a {name} de
            acceder a Zoom
          </p>,
        ],
      },
      {
        title: "Uso:",
        texts: [
          <p>
            La integración con Zoom se da para poder agendar nuevas reuniones
            denominadas clases
          </p>,
          <p>
            Algunos de los roles para crear clases serán administradores y
            maestros
          </p>,
          <p>
            Para todos los casos se utiliza para consultas, por ejemplo: los
            padres y alumnos podrán acceder a las clases y a su vez consultar el
            programa de clases virtuales asignadas
          </p>,
          <p>
            Para alumnos y padres no es necesaria la integración o dar permisos
            a {name} para consultar y acceder a sus respectivas clases. Para
            maestros y administrativos deben cumplir con el paso anterior
            "Instalación"
          </p>,
          <p>
            Para crear una clase el usuario deberá seleccionar el menú Aula
            virtual y dirigirse al sub menú Crear Clase, donde tendrá que elegir
            un grado, un grupo y modulo de clase, automáticamente se le
            proporcionara información para la agenda de zoom, el usuario podrá
            cambiarla de acuerdo a sus necesidades
          </p>,
          <p>
            Para iniciar una clase el usuario que ha creado la clase deberá
            seleccionar el menú Aula virtual y dirigirse al sub menú Consultar
            Clase, donde tendrá que seleccionar grado, grupo y fecha, podrá
            visualizar todas las clases que cumplan los criterios anteriores y
            podrá utilizar el botón Iniciar clase.
          </p>,
          <p>
            Ingresar a una clase el usuario deberá seleccionar el menú Aula
            virtual y dirigirse al sub menú Consultar Clase, donde tendrá que
            seleccionar grado, grupo y fecha, podrá visualizar todas las clases
            que cumplan los criterios anteriores y podrá utilizar el botón
            Ingresar a clase, en casos como el padre solo tendrá que seleccionar
            a su hijo y la fecha, en caso de que sea un alumno solo tendrá que
            elegir la fecha.
          </p>,
        ],
      },
      {
        title: "Desinstalación",
        texts: [
          <p>
            Para desinstalar o retirar los permisos de {name} a acceder a Zoom
            tiene dos opciones:
          </p>,
          <p className="uk-width-1-1">
            Zoom:
            <ol>
              <li>
                Ingresar a su cuenta de Zoom y dirigirse a Zoom App Marketplace.
              </li>
              <li>Click Manage -> Installed Apps.</li>
              <li>Click a {name}.</li>
              <li>Click a Uninstall.</li>
            </ol>
          </p>,
          <p className="uk-width-1-1">
            {name}
            <ol>
              <li>
                Ingresar a su cuenta de {name} y dirigirse a Aula virtual.
              </li>
              <li>Click Estatus -> Retirar permisos.</li>
              <li>
                {" "}
                Sin embargo, este paso solo eliminará los datos de {name}, por
                lo que aún tendrá que realizar el paso anterior "Desinstalar por
                Zoom"
              </li>
            </ol>
          </p>,
        ],
      },
      {
        title: "Soporte",
        texts: [
          <p>
            Por favor vaya a <a href={page + "/support"}>{page + "/support"}</a>
          </p>,
        ],
      },
    ],
  };

  const renderTerms = text[language].map((it, i) => {
    const renderTexts = it.texts.map((item) => {
      return item;
    });
    return (
      <Card
        key={i + "tac"}
        title={it.title}
        child={<Row className="uk-width-1-1">{renderTexts}</Row>}
      />
    );
  });

  return (
    <Grid>
      <Header />
      <Row
        className="uk-width-1-1 centerAll"
        style={{ margin: "14vh 0 0 0 ", padding: 0 }}
      ></Row>
      <Row
        className="uk-width-1-1 centerAll encabezado Color3"
        style={{ margin: "0 0 20px 0", padding: 0, lineHeight: 1 }}
      >
        {language === "es" ? "Documentación" : "Documentation"}
      </Row>
      <Row
        className="uk-width-1-1 centerAll subnegritas"
        style={{ margin: "20px 0", padding: 0, lineHeight: 1 }}
      >
        {language === "es"
          ? "A continuación te presentamos como acceder a Zoom a través de"
          : "Here's how to access Zoom through"}
        <br />
        {name}
      </Row>
      <Row
        className="uk-width-1-1 centerAll"
        style={{ margin: 0, padding: 10 }}
      >
        <Row
          className="uk-width-1-6@m uk-width-1-3@s uk-width-1-2 centerAll"
          style={{ margin: 0, padding: 3 }}
        >
          <Row
            className="uk-width-1-1 centerAll normal_text"
            style={{
              margin: 0,
              borderRadius: 6,
              padding: 8,
              backgroundColor:
                language === "es" ? AppEnv.thirdColor : AppEnv.grayColorOne,
              color: language === "es" ? AppEnv.fourthColor : AppEnv.fifthColor,
              textAlign: "center",
            }}
            onClick={() => setLanguage("es")}
          >
            <label className="uk-text-truncate">Español</label>
          </Row>
        </Row>
        <Row
          className="uk-width-1-6@m uk-width-1-3@s uk-width-1-2 centerAll"
          style={{ margin: 0, padding: 3 }}
        >
          <Row
            className="uk-width-1-1 centerAll normal_text"
            style={{
              margin: 0,
              borderRadius: 6,
              padding: 8,
              backgroundColor:
                language === "en" ? AppEnv.thirdColor : AppEnv.grayColorOne,
              color: language === "en" ? AppEnv.fourthColor : AppEnv.fifthColor,
              textAlign: "center",
            }}
            onClick={() => setLanguage("en")}
          >
            <label className="uk-text-truncate">English</label>
          </Row>
        </Row>
      </Row>
      <Row
        className="uk-width-1-1 centerAll"
        style={{ margin: 0, padding: "0 0 30px 0" }}
      >
        {renderTerms}
      </Row>
      <Footer />
    </Grid>
  );
}
